<form class="modal-body wrapper-modal position-relative assignment-dispatch-dialog" [formGroup]="form"
  (ngSubmit)="onSubmit()">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="close()"></i>

  <p class="title text-center text-break">
    {{ operation === 'changeState' ? 'Actualizar estado del despacho' : 'Editar observación del despacho' }}
  </p>

  <div class="assignment-dispatch-dialog__content">
    <mat-form-field appearance="outline" class="w-100" *ngIf="operation === 'changeState'">
      <mat-label>Nuevo estado<span class="asterisk">*</span></mat-label>
      <mat-select formControlName="state">
        <mat-option *ngFor="let stateOption of data.availableStates" [value]="stateOption.name">
          {{ stateOption.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('state')?.hasError('required')">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>
        Observación
        <span class="asterisk" *ngIf="operation === 'changeObservations'">*</span>
        <span class="optional" *ngIf="operation === 'changeState'"> (opcional)</span>
      </mat-label>
      <textarea matInput formControlName="observations" maxlength="240" rows="4"
        placeholder="Escribe una observación"></textarea>
      <mat-hint align="end">{{ form.get('observations')?.value?.length || 0 }}/240</mat-hint>
      <mat-error *ngIf="form.get('observations')?.hasError('required')">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
      <mat-error *ngIf="form.get('observations')?.hasError('maxlength')">
        {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'observaciones', 240) }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="button-container mt-3 justify-content-end">
    <button mat-raised-button class="primary-secondary button-width-auto mx-1" color="primary" type="button"
      (click)="close()">
      Cancelar
    </button>
    <button mat-raised-button class="button-width-auto bg-color-primary mx-1" color="primary" type="submit">
      Guardar
    </button>
  </div>
</form>